import type { SxProps, Theme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import MuiTypography from '@mui/material/Typography';

const textFieldLineHeight = 1.6;
const textFieldInlineErrorLineHeight = 1;
const textDisplayTitleLineHeight = 1.2;

export const textInlineEmphasisSx: SxProps<Theme> = {
  color: 'text.link',
  display: 'inline-block',
  fontSize: 16,
  fontStyle: 'normal',
  fontWeight: 600,
  letterSpacing: 0,
  lineHeight: 1.2,
  verticalAlign: 'baseline',
};

export const textFieldLabelSx: SxProps<Theme> = {
  color: 'neutral.black',
  display: 'block',
  fontSize: 16,
  fontStyle: 'normal',
  fontWeight: 400,
  letterSpacing: 0,
  lineHeight: textFieldLineHeight,
};

export const textFieldInlineErrorSx: SxProps<Theme> = {
  color: 'error.main',
  display: '-webkit-box',
  flex: '1 1 auto',
  fontSize: 12,
  fontStyle: 'normal',
  fontWeight: 700,
  letterSpacing: 0,
  lineHeight: textFieldInlineErrorLineHeight,
  maxHeight: '24px',
  minHeight: 0,
  minWidth: 0,
  overflow: 'hidden',
  overflowX: 'hidden',
  overflowY: 'hidden',
  scrollbarWidth: 'none',
  textAlign: 'right',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  wordBreak: 'break-word',
  '&::-webkit-scrollbar': {
    display: 'none',
    height: 0,
    width: 0,
  },
};

export const textDisplayTitleSx: SxProps<Theme> = {
  color: 'neutral.black',
  fontSize: { xs: 30, sm: 32 },
  fontStyle: 'normal',
  fontWeight: 700,
  letterSpacing: 0,
  lineHeight: textDisplayTitleLineHeight,
  margin: 0,
};

export const StyledText = styled(MuiTypography)({}) as typeof MuiTypography;
